export default __webpack_public_path__ + "static/media/NF.45a606da.svg";